import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { IL_COLORS } from "../../../../constants/investmentLeague";

const SummaryMetrics = ({ metrics = [] }) => {
  const theme = useTheme();
  const t     = theme.custom;

  const subColor = (key) => {
    if (key === "positive") return IL_COLORS.positive;
    if (key === "negative") return IL_COLORS.negative;
    return t.text3;
  };

  return (
    <Box
      sx={{
        display:             "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
          lg: "repeat(5, 1fr)",
        },
        gap: 2,
        mb:  3,
      }}
    >
      {metrics.map((metric) => (
        <Box
          key={metric.label}
          sx={{
            background:   t.surface,
            border:       `1px solid ${t.border2}`,
            borderRadius: "10px",
            p:            2.5,
          }}
        >
          <Typography
            sx={{
              fontSize:      "10px",
              fontWeight:    600,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color:         t.text3,
              mb:            1,
            }}
          >
            {metric.label}
          </Typography>
          <Typography
            sx={{
              fontSize:   { xs: "20px", md: "22px" },
              fontWeight: 700,
              color:      metric.valueColor === "positive"
                ? IL_COLORS.positive
                : metric.valueColor === "negative"
                  ? IL_COLORS.negative
                  : metric.subColor === "positive"
                    ? IL_COLORS.positive
                    : t.text,
              mb:         0.5,
              lineHeight: 1.2,
            }}
          >
            {metric.value}
          </Typography>
          <Typography
            sx={{
              fontSize:   "11px",
              color:      subColor(metric.subColor),
              display:    "flex",
              alignItems: "center",
              gap:        0.5,
            }}
          >
            {metric.subColor === "positive" && (
              <Box component="span" sx={{ fontSize: "10px", lineHeight: 1 }}>↑</Box>
            )}
            {metric.subColor === "negative" && (
              <Box component="span" sx={{ fontSize: "10px", lineHeight: 1 }}>↓</Box>
            )}
            {metric.sub}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default SummaryMetrics;
